import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ScrollToTop } from './components/ScrollToTop';
// Lazy load ShopPage — not needed on initial landing
const ShopPage = lazy(() => import('./pages/ShopPage').then(m => ({
  default: m.ShopPage
})));
const AuthPage = lazy(() => import('./pages/AuthPage').then(m => ({
  default: m.AuthPage
})));
const UserAreaPage = lazy(() => import('./pages/UserAreaPage').then(m => ({
  default: m.UserAreaPage
})));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage').then(m => ({
  default: m.ResetPasswordPage
})));
export function App() {
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/tienda" element={<Suspense fallback={<div className="min-h-screen bg-[#0A0A0B]" data-id="element-6" />} data-id="element-5">
              <ShopPage data-id="element-7" />
            </Suspense>} data-id="element-4" />
        <Route path="/area-usuario/login" element={<Suspense fallback={<div className="min-h-screen bg-[#0A0A0B]" data-id="element-10" />} data-id="element-9">
              <AuthPage data-id="element-11" />
            </Suspense>} data-id="element-8" />
        <Route path="/area-usuario" element={<Suspense fallback={<div className="min-h-screen bg-[#0A0A0B]" data-id="element-14" />} data-id="element-13">
              <UserAreaPage data-id="element-15" />
            </Suspense>} data-id="element-12" />
        <Route path="/area-usuario/reset-password" element={<Suspense fallback={<div className="min-h-screen bg-[#0A0A0B]" data-id="element-18" />} data-id="element-17">
              <ResetPasswordPage data-id="element-19" />
            </Suspense>} data-id="element-16" />
      </Routes>
    </>;
}